import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import { RADII } from 'styles/consts'

export const Tabbar = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  background: ${COLORS.surface};
  border: 1px solid ${COLORS.border};
  border-radius: ${RADII.field};
  /* 3px inset around the sliding pill — keep INNER_CHROME_WIDTH in index.tsx in sync. */
  padding: 3px;
  box-sizing: border-box;
`

/* Sliding indicator behind the tabs. No inline inset is set so the static
   position (content-box start) works in both LTR and RTL; the transform
   sign handles direction. */
export const ActiveTab = styled.div<{
  $activeTabIndex: number
  $isRTLDirection: boolean
  $tabWidth: number
}>`
  position: absolute;
  z-index: 1;
  top: 3px;
  bottom: 3px;
  background: ${COLORS.primaryTint};
  border: 1px solid ${COLORS.primary};
  border-radius: 6px;
  box-sizing: border-box;
  pointer-events: none;

  transform: ${props => {
    const sign = props.$isRTLDirection ? -1 : 1
    return (
      props.$activeTabIndex &&
      css`
        translateX(${sign * props.$tabWidth * props.$activeTabIndex}px);
  `
    )
  }};
  width: ${props => `${props.$tabWidth}px`};
`

export const FlatTabbarWrapper = styled.div<{
  $withoutPadding: boolean
  $isTabbarVisible: boolean
  $height: number
}>`
  width: 100%;
  height: ${props => props.$height}px;
  opacity: ${props => (props.$isTabbarVisible ? '1' : '0')};
`
